import { getUserFiles, getUserPhotosAndVideos, getUserDocuments, getUserMusic, getUserMusicByAlbum, getUserMusicByArtist, getUserMusicArtists, getUserMusicAlbums, getUserCollections, getUserCollectionById, getSharedCollectionById, getUserPlaylists, getUserPlaylistById, getUserTrash, getUserRepositoryFolder, getUserRepositories, getShareResources, getShares, getCategories, getProducts, getPlaylistListByUri, getFolderWithUri, getSubCategories, getRecentOrder, getCart, getEnhancedPlans, validateAndCreateRepo, getOrderById, getTaggingEnrollment, getMostUsedPersons, updatePerson, getFilesByPerson, getPersonsByFile, eSearch, } from '..';
const missingParamError = (apiMethod, paramName) => {
    return new Error(`${apiMethod} missing required ${paramName} parameter`);
};
export default async (apiMethod, props, params = [], lcid, cacheProps) => {
    switch (apiMethod) {
        case 'getUserFiles':
            return getUserFiles(props);
        case 'getUserPhotosAndVideos':
            return getUserPhotosAndVideos(props);
        case 'getUserDocuments':
            return getUserDocuments(props);
        case 'getUserMusic':
            return getUserMusic(props);
        case 'getUserMusicByAlbum': {
            if (params.length) {
                return getUserMusicByAlbum(props, params[0]);
            }
            throw missingParamError(apiMethod, 'album');
        }
        case 'getUserMusicByArtist': {
            if (params.length) {
                return getUserMusicByArtist(props, params[0]);
            }
            throw missingParamError(apiMethod, 'artist');
        }
        case 'getUserMusicArtists':
            return getUserMusicArtists(props);
        case 'getUserMusicAlbums':
            return getUserMusicAlbums(props);
        case 'getUserCollections':
            return getUserCollections(props, lcid, cacheProps);
        case 'getUserCollectionById': {
            if (params.length) {
                return getUserCollectionById(props, params[0], lcid, cacheProps);
            }
            throw missingParamError(apiMethod, 'id');
        }
        case 'getSharedCollectionById': {
            if (params.length) {
                return getSharedCollectionById(props, params[0], cacheProps);
            }
            throw missingParamError(apiMethod, 'id');
        }
        case 'getUserPlaylists':
            return getUserPlaylists(props);
        case 'getUserPlaylistById': {
            if (params.length) {
                return getUserPlaylistById(params[0], props);
            }
            throw missingParamError(apiMethod, 'id');
        }
        case 'getPlaylistListByUri': {
            if (params.length) {
                return getPlaylistListByUri(params[0], props);
            }
            throw missingParamError(apiMethod, 'uri');
        }
        case 'getFolderWithUri': {
            if (params.length) {
                return getFolderWithUri(params[0], props);
            }
            throw missingParamError(apiMethod, 'uri');
        }
        case 'getUserTrash':
            return getUserTrash(props);
        case 'getUserRepositories':
            return getUserRepositories(props);
        case 'getShareResources':
            const { count } = props;
            return getShareResources(params[1], parseInt(String(count)), undefined, cacheProps);
        case 'getUserRepositoryFolder':
            if (params.length) {
                return getUserRepositoryFolder(props, params[0]);
            }
            throw missingParamError(apiMethod, 'repository');
        case 'getShares':
            return getShares(props);
        case 'getCategories':
            return getCategories(props);
        case 'getSubCategories':
            return getSubCategories(props);
        case 'getProducts':
            return getProducts(props);
        case 'getRecentOrder':
            return getRecentOrder();
        case 'getCart':
            return getCart(props);
        case 'getEnhancedPlans':
            return getEnhancedPlans();
        case 'getTaggingEnrollment':
            return getTaggingEnrollment();
        case 'getOrderById':
            return getOrderById(props);
        case 'validateAndCreateRepo':
            return validateAndCreateRepo(props);
        case 'getMostUsedPersons':
            return getMostUsedPersons(props);
        case 'updatePerson':
            return updatePerson(props);
        case 'getFilesByPerson':
            return getFilesByPerson(props);
        case 'getPersonsByFile':
            return getPersonsByFile(props);
        case 'eSearch':
            return eSearch(props);
        default:
            throw new Error(`Api ${apiMethod} not found`);
    }
};
